import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { buttonReset } from '../styled/buttons';
import { Container } from '../styled/containers';

export const Wrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderDark};
  padding-bottom: ${({ theme }) => theme.spacing.small};

  &:hover {
    background: ${({ theme }) => `${theme.palette.lightBackground}`};
  }
`;

export const Heading = styled.h3`
  font-size: ${({ theme }) => theme.fontsize.h4};
  margin: 0;
  padding: 0;
`;

export const AccordionHeading = styled.h2`
  padding-left: ${({ theme }) => theme.spacing.standard};
`;

export const HeadingButton = styled.button`
  ${buttonReset};
  display: block;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.standard};
  padding-bottom: ${({ theme }) => theme.spacing.tiny};
  text-align: left;

  &:hover {
    color: ${({ theme }) => theme.palette.primaryLinkHover};
  }
`;

export const HeadingText = styled.span`
  display: block;
`;

export const Content = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing.tiny} ${theme.spacing.standard} 0 ${theme.spacing.standard}`};

  a {
    &:hover {
      color: ${({ theme }) => theme.palette.primaryLinkHover};
    }
  }
`;

export const IconSVG = styled(SVG)`
  min-width: ${({ theme }) => theme.spacing.standard};
  height: ${({ theme }) => theme.spacing.standard};
  margin-right: ${({ theme }) => theme.spacing.small};
`;

export const HideShowText = styled.span`
  font-size: ${({ theme }) => `${theme.fontsize.base}`};
`;

export const AccordionsWrapper = styled(Container)`
  margin-top: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.large};
`;
